import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Gleam Bay',
    description: "Hand car wash and valeting centre. Snow foam washes, interior valets and paint protection with clear prices and online booking.",
    url: getOrigin(),
    ogImage: '/images/clean-sedan.jpg'
}
